import {isFlutterMobileAppUserAgent} from './isFlutterMobileAppUserAgent'

/**
 * Determine whether this code is running in a webview in the Flutter App.
 * This will NOT target code which runs in React Native or the React Native webview in the mobile app
 */
const isFlutterAppWebView = (): boolean => {
  return isFlutterMobileAppUserAgent()
}

export {isFlutterAppWebView}
